/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'
import { LogedInUserInfo } from '@components/molecules/user/LogedInUserInfo'
import { mono } from '@components/systems/backoffice/backoffice.tokens'

import packageJson from '../../../../package.json'
import { useAppSelector } from '@redux/index'
import { useDrawerOpen } from '@components/systems/backoffice/BoShellContext'

/** 사이드바 바닥 — 상단 헤어라인, 계정 + 버전 */
export const DrawerBottomView = () => {
	const isOpenDrawer: boolean = useDrawerOpen()

	return (
		<View css={style}>
			<LogedInUserInfo />
			{isOpenDrawer ? (
				<span className="version">{`v ${packageJson.version}`}</span>
			) : null}
		</View>
	)
}

const style = css({
	flexShrink: 0,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	gap: 8,
	width: '100%',
	minHeight: 56,
	padding: '0 12px 0 14px',
	borderTop: `1px solid ${mono.line}`,

	'.version': {
		flexShrink: 0,
		fontSize: 11,
		fontWeight: 300,
		letterSpacing: '.04em',
		color: mono.faint,
		fontVariantNumeric: 'tabular-nums',
	},
})
